import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const loginWhenUnauthorized = (error: any, url: string) => {
    if (error.response && error.response.status === 401) {
        let l = window.location.pathname
        localStorage.removeItem('token');
        if (!url.includes("auth") && !(l.includes('verify') || l.includes('process') || l.includes('imprint') || l.includes('privacy'))) {
            window.location.href = '/auth-pages/login';
        }
    }
    return Promise.reject(error);
};

const defaultOptions: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'text/html, application/pdf',
  },
  validateStatus: function (status: number) {
    return status >= 200 && status < 300;
  },
};

export const instance = axios.create(defaultOptions);


instance.interceptors.request.use(function (config: any) {
	const token = localStorage.getItem('token') ?? '{}';
	config.headers.Authorization = token
		? `Bearer ${token}`
		: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJiODVhYTU0ZS0yZjE2LTQ1ZDgtODMxYy1iZmMxOWZiMzAwNTAiLCJhenAiOiI4NWYwM2M3Zi1lZGZlLTQ4MTMtYWJlNi05YzBhYTA5MGYyYjAiLCJwZXJtaXQiOltdLCJpYXQiOjE2OTcxMDI0MDgsImV4cCI6MTY5NzEwNjAwOH0.zDBpAuxIuVHAWtIDHB0tqoXWUfRnwLFnvw_NfQ1MAR4';
		return config;
});

const responseBody = (response: AxiosResponse) => response.data;

export const requests = {
    get: (url: string, params?: any) =>
        instance
            .get(url, { params })
            .then(responseBody)
            .catch((error) => loginWhenUnauthorized(error, url)),
    post: (url: string, body?: {}, config?: AxiosRequestConfig) =>
        instance
            .post(url, body, config)
            .then(responseBody)
            .catch((error) => loginWhenUnauthorized(error, url)),
    put: (url: string, body?: {}, config?: AxiosRequestConfig) =>
        instance
            .put(url, body, config)
            .then(responseBody)
            .catch((error) => loginWhenUnauthorized(error, url)),
    patch: (url: string, body?: {}, config?: AxiosRequestConfig) =>
        instance
            .patch(url, body, config)
            .then(responseBody)
            .catch((error) => loginWhenUnauthorized(error, url)),
    delete: (url: string, config?: AxiosRequestConfig) =>
        instance
            .delete(url, config)
            .then(responseBody)
            .catch((error) => loginWhenUnauthorized(error, url)),
};
